export const navbar = {
  buttons: [
    {
      text: "CREAR CUENTA",
      href: "/register",
      buttonType: "default",
    },
    {
      text: "INICIAR SESIÓN",
      href: "/home",
      buttonType: "transparent",
    },
  ],
};
